// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useQueryClient } from "@tanstack/react-query";
// import toast from "react-hot-toast";
// import styles from "./checkoutpayment.module.css";
// import PaymentSection from "./PaymentSection";
// import CheckoutOrderSummary from "./CheckoutOrderSummary";
// import { useAddOrderMutation } from "../../../../queries/useOrderQuery";
// import { useRemoveCartItem } from "../../../../queries/useCartQuery";
// import { useOrderSummary } from "../../../../hooks/useOrderSummary";
// import { paymentOptions } from "../../../../constants/payment-options";
// import { CART, USER_ORDERS } from "../../../../constants/query.constants";
// import { payWithPaypal, payWithPayU } from "../../../../repositories/orders/orderRepository";
// const CheckoutPayment = () => {
//   const navigate = useNavigate();
//   const queryClient = useQueryClient();
//   const [selectedPayment, setSelectedPayment] = useState(null);
//   const [storedAddress, setStoredAddress] = useState(null);
//   const [savedShipping, setSavedShipping] = useState(null);
//   /* =========================
//      LOAD CHECKOUT DATA
//   ========================= */
//   useEffect(() => {
//     try {
//       const address = JSON.parse(localStorage.getItem("checkoutAddress"));
//       const shipping = JSON.parse(localStorage.getItem("shipping-rules"));
//       if (!address || !shipping) {
//         toast.error("Checkout data missing");
//         navigate("/cart");
//         return;
//       }
//       setStoredAddress(address);
//       setSavedShipping(shipping);
//     } catch {
//       toast.error("Invalid checkout data");
//       navigate("/cart");
//     }
//   }, [navigate]);
//   /* =========================
//      ORDER SUMMARY
//   ========================= */
//   const {
//     cartItems,
//     subtotal,
//     shipping,
//     tax,
//     total,
//     totalQty,
//     isPending: isCartPending,
//   } = useOrderSummary(savedShipping);
//   const orderSummary = { subtotal, shipping, tax, total, totalQty };
//   /* =========================
//      MUTATIONS
//   ========================= */
//   const { mutateAsync: placeOrder, isPending: isOrderPlacePending } =
//     useAddOrderMutation();
//   const { mutateAsync: removeCartItem } = useRemoveCartItem();
//   const clearCart = async () => {
//     for (const item of cartItems) {
//       await removeCartItem(item.id);
//     }
//     queryClient.invalidateQueries([CART]);
//     queryClient.invalidateQueries([USER_ORDERS]);
//   };
//   /* =========================
//      PLACE ORDER
//   ========================= */
//   const handlePlaceOrder = async () => {
//     if (!selectedPayment) {
//       toast.error("Select payment method!");
//       return;
//     }
//     const payload = {
//       sub_total: Number(subtotal),
//       amount: Number(total),
//       product_qty: Number(totalQty),
//       order_address: storedAddress,
//       shipping_method: savedShipping,
//       products: cartItems.map((item) => ({
//         product_id: item.product_id || item.product?.id || null,
//         vendor_id: item.vendor_id || item.product?.vendor_id || null,
//         product_name:
//           item.product_name || item.product?.name || item.name || "",
//         unit_price: Number(item.price || item.unit_price || 0),
//         qty: Number(item.quantity || item.qty || 1),
//       })),
//     };
//     try {
//       /* =========================
//          PAYU PAYMENT
//       ========================= */
//       // if (selectedPayment === "payu") {
//       //   const res = await payWithPayU(payload);
//       //   if (!res?.payu) {
//       //     toast.error("Invalid PayU response");
//       //     return;
//       //   }
//       //   const payuPayload = {
//       //     ...res.payu,
//       //     cart_ids: cartItems.map(item => item.id),
//       //   };
//       //   localStorage.setItem("payu_payload", JSON.stringify(payuPayload));
//       //   localStorage.setItem("payu_payload", JSON.stringify(payuPayload));
//       //   navigate("/web-app/checkout/payu-redirect");
//       //   return;
//       // }
//       // PAY PAL
//       // if (selectedPayment === "paypal") {
//       //   const response = await payWithPaypal(payload);
//       //   if (!response?.approval_url) {
//       //     toast.error("PayPal approval URL not received");

//       //     return;
//       //   }
//       //   // ✅ Redirect to PayPal page
//       //   window.location.href = response.approval_url;

//       //   return;
//       // }
//       /* =========================
//          CASH ON DELIVERY
//       ========================= */
//       if (selectedPayment === "cod") {
//         const response = await placeOrder(payload);
//         const invoiceId = response?.order?.invoice_id;
//         const orderId = response?.order?.id;
//         await clearCart();
//         toast.success("COD order placed successfully 🎉");
//         navigate("/checkout/success", {
//           state: { invoiceId, orderId },
//         });
//         return;
//       }
//     }catch (err) {
//   console.log("🔥 FULL ERROR:", err);

//   console.log("🔥 STATUS:", err?.response?.status);
//   console.log("🔥 DATA:", err?.response?.data);
//   console.log("🔥 MESSAGE:", err?.message);

//   toast.error(
//     err?.response?.data?.message ||
//     err?.response?.data?.error ||
//     err?.message ||
//     "Order failed"
//   );
//     }
//   };
//   if (!storedAddress || !savedShipping) return null;
//   return (
//     <section className={styles.wrapper}>
//       <div className={styles.contentContainer}>
//         <PaymentSection
//           paymentOptions={paymentOptions}
//           selectedPayment={selectedPayment}
//           setSelectedPayment={setSelectedPayment}
//         />
//         <CheckoutOrderSummary
//           cartItems={cartItems}
//           orderSummary={orderSummary}
//           isCartPending={isCartPending}
//           handlePlaceOrder={handlePlaceOrder}
//           isOrderPlacePending={isOrderPlacePending}
//           isLoading={isOrderPlacePending}
//            selectedPayment={selectedPayment}
//         />
//         {/* ✅ PAYPAL BUTTON */}
//       </div>
//     </section>
//   );
// };
// export default CheckoutPayment;

import { useState, useEffect } from "react";
import { useNavigate ,useLocation } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";

import styles from "./checkoutpayment.module.css";
import PaymentSection from "./PaymentSection";
import CheckoutOrderSummary from "./CheckoutOrderSummary";

import { useAddOrderMutation } from "../../../../queries/useOrderQuery";
import { useRemoveCartItem } from "../../../../queries/useCartQuery";

import { paymentOptions } from "../../../../constants/payment-options";
import { CART, USER_ORDERS } from "../../../../constants/query.constants";
import {
  payWithRazorpay,
  razorpayPaymentFailed,
  verifyRazorpayPayment,
} from "../../../../repositories/orders/orderRepository";



const CheckoutPayment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();
  const [prescriptions, setPrescriptions] = useState({});
const [showGlobalLoader, setShowGlobalLoader] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [storedAddress, setStoredAddress] = useState(null);
  const [savedShipping, setSavedShipping] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("productPrescriptions");
    if (!stored) return;
    const parsed = JSON.parse(stored);
    const rebuilt = {};
    Object.entries(parsed).forEach(([productId, files]) => {
      rebuilt[productId] = files.map((f) => {
        const arr = f.base64.split(",");
        const mime = f.type;
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return {
          file: new File([u8arr], f.name, { type: mime }),
        };
      });
    });
    setPrescriptions(rebuilt);
  }, []);
  /* =========================
     LOAD CHECKOUT DATA
  ========================= */
  useEffect(() => {
    try {
      const address = JSON.parse(localStorage.getItem("checkoutAddress"));
      const shipping = JSON.parse(localStorage.getItem("shipping-rules"));

      if (!address || !shipping) {
        toast.error("Checkout data missing");
        navigate("/cart");
        return;
      }

      setStoredAddress(address);
      setSavedShipping(shipping);
    } catch {
      toast.error("Invalid checkout data");
      navigate("/cart");
    }
  }, [navigate]);

  /* =========================
     ORDER SUMMARY
  ========================= */ 
  const buyNowItem = location.state?.buyNow
  ? [
      {
        id: location.state.product.id,
        quantity: location.state.quantity,
        product: location.state.product,
      },
    ]
  : null;
 const selectedCartItems = buyNowItem
  ? buyNowItem
  : JSON.parse(localStorage.getItem("selectedCheckoutItems")) || [];
const selectedCount = selectedCartItems.length;
  const subtotal = selectedCartItems.reduce((acc, item) => {
  const price = Number(
  item.product?.offer_price > 0
    ? item.product.offer_price
    : item.product?.price || item.price || 0
);

    return acc + price * Number(item.quantity || 1);
  }, 0);

  const totalQty = selectedCartItems.reduce(
    (acc, item) => acc + Number(item.quantity || 1),
    0,
  );

  const shipping = Number(savedShipping?.cost || 0);
  const tax = 0;
  const total = subtotal + shipping;
  const isCartPending = false;

  const orderSummary = {
    subtotal,
    shipping,
    tax,
    total,
    totalQty,
  };

  /* =========================
     MUTATIONS
  ========================= */
  const { mutateAsync: placeOrder, isPending: isOrderPlacePending } =
    useAddOrderMutation();

  const { mutateAsync: removeCartItem } = useRemoveCartItem();

  /* =========================
     CLEAR CART
  ========================= */
 const clearCart = async () => {
  if (buyNowItem) return;  

  for (const item of selectedCartItems) {
    await removeCartItem(item.id);
  }

  queryClient.invalidateQueries([CART]);
  queryClient.invalidateQueries([USER_ORDERS]);
};

  /* =========================
     PLACE ORDER
  ========================= */
  const handlePlaceOrder = async () => {
    if (!selectedPayment) {
      toast.error("Select payment method!");
      return;
    } 
      setShowGlobalLoader(true);
    const payload = {
      sub_total: Number(subtotal),
      amount: Number(total),
      product_qty: Number(totalQty),
      order_address: storedAddress,
      shipping_method: savedShipping,
      products: selectedCartItems.map((item) => ({
        product_id: item.product_id || item.product?.id || null,
        vendor_id: item.vendor_id || item.product?.vendor_id || null,
        product_name:
          item.product_name || item.product?.name || item.name || "",
        unit_price: Number(item.price || item.unit_price || 0),
        qty: Number(item.quantity || item.qty || 1),
      })),
    };
    try {
      const formData = new FormData();      

      /* BASIC */
      formData.append("sub_total", Number(subtotal || 0));
      formData.append("amount", Number(total || 0));
      formData.append("product_qty", Number(totalQty || 0));

      /* =========================
         ORDER ADDRESS
      ========================= */
      Object.entries(storedAddress || {}).forEach(([key, value]) => {
        formData.append(`order_address[${key}]`, value);
      });

      /* =========================
         SHIPPING
      ========================= */
      Object.entries(savedShipping || {}).forEach(([key, value]) => {
        formData.append(`shipping_method[${key}]`, value);
      });

      /* =========================
         PRODUCTS
      ========================= */
      selectedCartItems.forEach((item, index) => {
        const productId = item.product_id || item.product?.id || "";

        const vendorId = item.vendor_id || item.product?.vendor_id || "";

        console.log("🛒 ITEM:", item);
        console.log("✅ PRODUCT ID:", productId);
        console.log("✅ VENDOR ID:", vendorId);

        // optional frontend validation
        if (!vendorId) {
          throw new Error(
            `Vendor ID missing for product: ${
              item.product_name || item.product?.name || "Unknown Product"
            }`,
          );
        }

        formData.append(`products[${index}][product_id]`, productId);

        // ✅ IMPORTANT FIX
        formData.append(`products[${index}][vendor_id]`, vendorId);

        formData.append(
          `products[${index}][product_name]`,
          item.product_name || item.product?.name || item.name || "",
        );

        formData.append(
          `products[${index}][unit_price]`,
          Number(item.price || item.unit_price || 0),
        );

        formData.append(
          `products[${index}][qty]`,
          Number(item.quantity || item.qty || 1),
        );
      });

      /* =========================     
         PRESCRIPTION IMAGE
      ========================= */
      Object.entries(prescriptions).forEach(([productId, files]) => {
        files.forEach((fileObj, index) => {
          formData.append(
            `prescriptions[${productId}][${index}]`,
            fileObj.file,
          );
        });
      });
      if (selectedPayment === "razorpay") {
         setShowGlobalLoader(false); 
        const res = await payWithRazorpay(payload);

        if (!res?.order || !res?.key) {
          toast.error("Razorpay order creation failed");
          return;
        }

        const { order, key } = res;

        const options = {
          key,

          amount: order.amount,

          currency: order.currency,

          name: "Your Store",

          description: "Order Payment",

          order_id: order.id,

          handler: async (paymentResponse) => {
            try { 
              setShowGlobalLoader(true);
              const verifyRes = await verifyRazorpayPayment({
                razorpay_payment_id: paymentResponse.razorpay_payment_id,
                razorpay_order_id: paymentResponse.razorpay_order_id,
                razorpay_signature: paymentResponse.razorpay_signature,
              });
              console.log("VERIFY RESPONSE:", verifyRes);
              toast.success("Payment successful 🎉");

              navigate("/checkout/order-success", {
                state: {
                  payment_id: paymentResponse.razorpay_payment_id,
                  payment_method: "Razorpay", // force correct value
                  orderId: order?.id,
                  invoice_id: order?.invoice_id,
                },
              });
            } catch (err) {
              console.error(err);
              toast.error("Payment verification failed");
            }
          },

          modal: {
            ondismiss: async () => {
              console.log("RAZORPAY POPUP CLOSED");

              try {
                const res = await razorpayPaymentFailed({
                  razorpay_order_id: order.id,
                  reason: "cancelled_by_user",
                });

                console.log("FAILURE API RESPONSE:", res);
              } catch (err) {
                console.error("FAILURE API ERROR:", err);
              }

              toast.error("Payment cancelled");
            },
          },

          prefill: {
            name: storedAddress?.name || "",
            email: storedAddress?.email || "",
            contact: storedAddress?.phone || "",
          },

          theme: {
            color: "#3399cc",
          },
        };

        const razor = new window.Razorpay(options);

        razor.on("payment.failed", async (response) => {
          console.log("PAYMENT FAILED EVENT", response);

          try {
            const res = await razorpayPaymentFailed({
              razorpay_order_id: order.id,
              razorpay_payment_id:
                response?.error?.metadata?.payment_id || null,
              reason: response?.error?.description || "payment_failed",
            });

            console.log("FAILURE API RESPONSE:", res);
          } catch (err) {
            console.error("FAILURE API ERROR:", err);
          }

          // toast.error("Payment failed");
        });

        razor.open();

        return;
      }
      /* =========================
         CASH ON DELIVERY
      ========================= */
      if (selectedPayment === "cod") {
        const response = await placeOrder(formData);

        const invoiceId = response?.order?.invoice_id;
        const orderId = response?.order?.id;

        await clearCart();

        toast.success("COD order placed successfully 🎉");

        navigate("/checkout/success", {
          state: {
            invoiceId,
            orderId,
          },
        });

        return;
      }
    } catch (err) {
      console.log("🔥 FULL ERROR:", err);
      console.log("🔥 STATUS:", err?.response?.status);
      console.log("🔥 DATA:", err?.response?.data);
      console.log("🔥 MESSAGE:", err?.message);

      toast.error(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Order failed",
      );
    }
  };

  if (!storedAddress || !savedShipping) return null;

  return ( 
    
     
    <section className={styles.wrapper}>
      <div className={styles.contentContainer}>
        <PaymentSection
          paymentOptions={paymentOptions}
          selectedPayment={selectedPayment}
          setSelectedPayment={setSelectedPayment}
        />

        <CheckoutOrderSummary
          cartItems={selectedCartItems}
          orderSummary={orderSummary}
          isCartPending={isCartPending}
          handlePlaceOrder={handlePlaceOrder}
          isOrderPlacePending={isOrderPlacePending}
          isLoading={isOrderPlacePending}
          selectedPayment={selectedPayment}
           selectedCount={selectedCount}
        />
      </div>
    </section>
    
  );
};

export default CheckoutPayment;
